/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { FindOptions } from './common';
import { entityService } from './services';

const pathname = '/diaries';

export const DiaryApi = {
  findByEntitySection: async (
    entitySectionID: string,
    options: FindByEntitySectionOptions
  ) => {
    let url = `${pathname}/entity-section/${entitySectionID}`;
    const query = serialize(options);
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },
};

export interface FindDiaryOptions extends FindOptions {
  where?: { stepID?: string; sectionID?: string; step?: any; section?: any };
}

export interface FindByEntitySectionOptions extends FindOptions {
  stepID?: string;
}
